import { animated, easings, useTransition } from '@react-spring/web'
import React, { useEffect, useState } from 'react'

/*
Note: Add a key to the <OpacityTransition> component to force a re-render when only children change within a component.
See EmployerInvoice.tsx for an example.
*/

const OpacityTransition = ({
  children,
  withHeight = false,
}: {
  children: React.ReactNode
  withHeight?: boolean
}) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(true)

    return () => setShow(false) // Cleanup interval on component unmount
  }, [])

  const transitions = useTransition(show, {
    from: { opacity: 0, y: withHeight ? 32 : 0 },
    enter: { opacity: 1, y: 0 },
    leave: { opacity: 0, y: 0 },
    config: withHeight
      ? {
          duration: 700,
          easing: easings.easeInBack,
        }
      : {},
  })

  return (
    <div>
      {transitions((style, item) =>
        item ? <animated.div style={style}>{children}</animated.div> : null
      )}
    </div>
  )
}

export const OpacityTransitionEnterAndLeave = ({
  children,
  visible,
  withHeight = false,
}: {
  children: React.ReactNode
  visible: boolean
  withHeight?: boolean
}) => {
  const transitions = useTransition(visible, {
    from: { opacity: 0, y: withHeight ? 32 : 0 },
    enter: { opacity: 1, y: 0 },
    leave: { opacity: 0, y: 0 },
    config: withHeight
      ? {
          duration: 700,
          easing: easings.easeInBack,
        }
      : {},
  })

  return (
    <div>
      {transitions((style, item) =>
        item ? <animated.div style={style}>{children}</animated.div> : null
      )}
    </div>
  )
}

export default OpacityTransition
